import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import './StatsBar.css';

const StatsBar = () => {
  const { t } = useTranslation();

  const stats = useMemo(() => [
    {
      lines: [t('stats.exp1', '6+ Years'), t('stats.exp2', 'Experience')],
      sub: t('stats.exp_sub', 'Industry Experience'),
      icon: (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <path d="M3.99878 39.987C3.99878 41.0475 4.42007 42.0646 5.16997 42.8145C5.91987 43.5644 6.93696 43.9857 7.99748 43.9857H39.9871C41.0476 43.9857 42.0647 43.5644 42.8146 42.8145C43.5645 42.0646 43.9858 41.0475 43.9858 39.987V15.9948L29.9903 25.9916V15.9948L15.9949 25.9916V7.99742C15.9949 6.9369 15.5736 5.91981 14.8237 5.16991C14.0738 4.42001 13.0567 3.99872 11.9962 3.99872H7.99748C6.93696 3.99872 5.91987 4.42001 5.16997 5.16991C4.42007 5.91981 3.99878 6.9369 3.99878 7.99742V39.987Z" stroke="white" strokeWidth="3.9987" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M33.989 35.9883H35.9884" stroke="white" strokeWidth="3.9987" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M23.9922 35.9883H25.9915" stroke="white" strokeWidth="3.9987" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M13.9954 35.9883H15.9947" stroke="white" strokeWidth="3.9987" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      lines: [t('stats.farm1', '50,000+'), t('stats.farm2', 'Happy'), t('stats.farm3', 'Customers')],
      sub: t('stats.farm_sub', 'Satisfied Customers'),
      icon: (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <path d="M31.9897 41.9863V37.9876C31.9897 35.8666 31.1471 33.8324 29.6473 32.3326C28.1475 30.8328 26.1133 29.9902 23.9923 29.9902H11.9962C9.87514 29.9902 7.84097 30.8328 6.34116 32.3326C4.84136 33.8324 3.99878 35.8666 3.99878 37.9876V41.9863" stroke="white" strokeWidth="3.9987" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M17.9942 21.9928C22.4111 21.9928 25.9916 18.4123 25.9916 13.9954C25.9916 9.5786 22.4111 5.99805 17.9942 5.99805C13.5774 5.99805 9.99683 9.5786 9.99683 13.9954C9.99683 18.4123 13.5774 21.9928 17.9942 21.9928Z" stroke="white" strokeWidth="3.9987" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M43.9856 41.9864V37.9877C43.9843 36.2157 43.3945 34.4943 42.3089 33.0939C41.2232 31.6934 39.7033 30.6932 37.9875 30.2502" stroke="white" strokeWidth="3.9987" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M31.9895 6.258C33.7098 6.69845 35.2345 7.69893 36.3234 9.10169C37.4122 10.5045 38.0032 12.2297 38.0032 14.0055C38.0032 15.7812 37.4122 17.5065 36.3234 18.9093C35.2345 20.312 33.7098 21.3125 31.9895 21.753" stroke="white" strokeWidth="3.9987" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      lines: [t('stats.prod1', '150+'), t('stats.prod2', 'Products'), t('stats.prod3', 'Range')],
      sub: t('stats.prod_sub', 'Quality Products'),
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
          <polyline points="17 6 23 6 23 12"></polyline>
        </svg>
      )
    },
    {
      lines: [t('stats.deal1', '250+'), t('stats.deal2', 'Dealer'), t('stats.deal3', 'Network')],
      sub: t('stats.deal_sub', 'Across Bihar'),
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="8" r="7"></circle>
          <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
        </svg>
      )
    }
  ], [t]);

  return (
    <section className="stats-bar">
      <div className="container">
        {/* Row of stats */}
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className={`stat-item stat-item-${index}`}>
              <div className="stat-icon">{stat.icon}</div>
              <div className="stat-content">
                {stat.lines.map((line, i) => (
                  <h2 key={i} className="stat-main">{line}</h2>
                ))}
                {stat.sub && <p className="stat-desc">{stat.sub}</p>}
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <div className="whatsapp-fab" onClick={() => window.open('https://wa.me/919631277264', '_blank')}>
        <svg viewBox="0 0 24 24" width="35" height="35" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.438 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.414 0 .004 5.412 0 12.046c0 2.123.555 4.195 1.608 6.014L0 24l6.117-1.605a11.782 11.782 0 005.925 1.587h.005c6.632 0 12.043-5.414 12.047-12.048a11.821 11.821 0 00-3.526-8.513"/>
        </svg>
      </div>
    </section>
  );
};

export default StatsBar;


